<template>
  <div class="pb100">
    <crumbs detail="true"/>
    <div class="container">
     <div class="detailmodel1 clearfix">
       <div class="leftcon fl">
         <h2 class="title">{{ detail.name }}</h2>
         <div class="imgtxtbox clearfix">
           <div class="imgbox fl">
             <div class="imgboxinner">
               <i class="icon-scale1"></i>
               <img class="imgtop" preview="0" :src="getImage(detail.image)" alt="">
             </div>
             <div class="labelbox">
               <el-button size="small" round v-show="detail.label !== undefined && detail.label !== ''">{{ detail.label }}</el-button>
             </div>
           </div>
           <div class="txtbox fr">
             <div class="con_detail">
               <p class="icon icon1" v-show="detail.ticketNumber !== undefined && detail.ticketNumber !== 0">余票<em class="red">{{ detail.ticketNumber }}</em>张</p>
               <p class="icon icon3" onclick="fnDaohang('35.474312','118.04832', detail.address);">{{ detail.address }}</p>
               <p class="icon icon4">
                 <input type="text" :value="getTime(detail.activityDate)" disabled="disabled">
               </p>
               <p class="icon icon5" v-show="detail.phone !== undefined && detail.phone !== ''">{{ detail.phone }}</p>
               <p class="icon icon6" v-show="detail.initiator !== undefined && detail.initiator !== ''">{{ detail.initiator }}</p>
               <div class="btnbox clearfix">
                 <el-button type="primary" round v-if="detail.flag === true && detail.status === 0" @click="enrollfun">我要报名</el-button>
                 <el-button type="info" round v-else-if="detail.status === 1">您已报名</el-button>
                 <el-button type="info" round v-else-if="detail.status === 2">您报名已审核</el-button>
                 <el-button type="info" round v-else-if="detail.status === 3">您报名已被拉黑</el-button>
                 <el-button type="info" round v-else-if="detail.status === 4">您报名已签到</el-button>
               </div>
             </div>
           </div>
         </div>
         <div class="contentbox" v-html="detail.content"></div>
         <comment @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
       </div>
       <div class="rightcon fr">
         <h2 class="title">推荐活动</h2>
         <ul v-if="List && List.length > 0">
           <li v-for="(item, index) in List" :key="index">
             <router-link :to="'/volunteeractivitydetail?columnId=' + item.menuId + '&id=' + item.id">
               <div class="imgbox">
                 <img class="imgtop" :src="getImage(item.image)" alt="">
               </div>
               <h4 class="textover">{{ item.name }}</h4>
             </router-link>
           </li>
         </ul>
         <h2 class="nodata mt20 mb20" v-if="nodataflag">暂无数据</h2>
       </div>
     </div>
    </div>
    <go-top></go-top>
    <right-sidebar
     :comment-count="commentTotal"
     :comment-gotop="commentOffsettop"
     :comment-show="isCommentshow"
     :title="detail.name"
     :image="getImage(detail.image)"
     :url="this.$route.fullPath"
     ref="rightSidebar"></right-sidebar>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import { timeFormat } from '@/utils/validate'
import { vactivityDetail, vactivityList, addvactivity } from '@/api/volunteer/index'
import goTop from '@/components/gotop/index'
import RightSidebar from '@/components/rightsidebar/index'
import Comment from '@/components/comment/index'
export default {
  name: 'volunteeractivitydetail',
  meta: {
    showHeader: true
  },
  components: {
    crumbs,
    goTop,
    RightSidebar,
    Comment
  },
  data () {
    return {
      Param: {
        fid: this.$cookie.get('culturalCloud_fid'),
        pageNum: 1,
        limit: 5,
        type: '',
        recommend: 1
      },
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0,
      detail: '',
      recommend: [],
      commentTotal: '',
      commentOffsettop: '',
      isCommentshow: true // 是否显示评论
    }
  },
  mounted () {
    this.getDetail()
    this.getList()
  },
  methods: {
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    getTime (val) {
      return timeFormat(val, 'yymmddhhmm')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    getDetail () {
      vactivityDetail(this.$route.query.id).then(res => {
        if (res.data.status === 200) {
          this.detail = res.data.data
          // this.recommend = res.data.data.recommendList
          // if (this.recommend.length === 0) this.noData = true
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getList () {
      vactivityList(this.Param).then(res => {
        if (res.data.status === 0) {
          this.listTotal = res.data.totalSize
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.List = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    enrollfun () {
      addvactivity(this.$route.query.id).then(res => {
        if (res.data.rel) {
          this.$message({
            message: res.data.message,
            type: 'success',
            duration: 1500
          })
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/volunteercenter/vappointmentdetail.vue